import React, { Fragment } from "react";
import Overlay from "../UI/Overlay";

export default function PasswordPopup({ children }) {
  return (
    <Fragment>
      <Overlay />
      <div className="w-[90%] lg:w-[60%] p-4 h-[260px] flex items-center justify-center bg-white z-[80] rounded-lg shadow-lg absolute top-[15%] left-5 lg:left-60">
        {children}
      </div>
    </Fragment>
  );
}
